import { cn } from "@/lib/utils";
import React from "react";

export const Container = ({
  children,
  className,
  fluid = false,
}: {
  children: React.ReactNode;
  className?: string;
  fluid?: boolean;
}) => {
  return (
    <div className={cn(
      fluid ? 'w-full' : 'max-w-7xl', 
      'mx-auto px-3 sm:px-4 md:px-6 lg:px-8',
      className
    )}>
      {children}
    </div>
  );
};
